var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTarteelText = function SvgTarteelText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 18,
    viewBox: "0 0 115 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.863 6H6v2.36h3.537V18h2.839V8.36h3.536V6h-.05Zm8.517 12h2.989L22.438 6h-2.64l-4.981 12h3.038l.797-2.008h5.03L24.38 18ZM19.5 13.632l1.643-4.117 1.594 4.117H19.5ZM35.886 18h3.288l-3.039-4.72c1.246-.652 2.043-1.857 2.043-3.364 0-2.36-1.694-3.916-4.234-3.916h-5.33v12h2.84v-4.167h1.892L35.886 18Zm-4.433-9.64h2.192c.996 0 1.644.653 1.644 1.556 0 .904-.748 1.557-1.893 1.557h-1.893V8.36h-.05ZM49.086 6h-9.862v2.36h3.536V18h2.84V8.36h3.536V6h-.05Zm4.383 9.64v-2.56h5.081v-2.31h-5.08V8.36h5.628V6H50.63v12h8.617v-2.36H53.47Zm10.66 0v-2.56h5.08v-2.31h-5.08V8.36h5.628V6H61.29v12h8.617v-2.36h-5.778Zm10.66 0V6h-2.84v12h7.87v-2.36h-5.03ZM93.815 18h1.295l-5.23-12h-1.146l-5.23 12H84.8l1.345-3.113h6.276L93.816 18Zm-7.223-4.167 2.74-6.327 2.69 6.327h-5.43ZM96.755 18H98V6h-1.245v12Z",
    fill: "#3B393E"
  })));
};

export default SvgTarteelText;